import 'fslightbox';
import Splide from "@splidejs/splide";
window.splide = Splide;

import { recommendedSlider } from "../../includes/blocks/block-recommended-slider/script";
import { homeBarFilter } from "./modules/homeBarFilter";

if (document.querySelectorAll(".blockRecommendedSlider")) {
	recommendedSlider();
}

if (document.querySelectorAll(".filtersHome__button")) {
	homeBarFilter();
}

// document.addEventListener('DOMContentLoaded', function () {
// 	const filtersButton = document.querySelector('.filtersHome__button');

// 	if (filtersButton) {
// 		filtersButton.addEventListener('click', function () {
// 			// Get the shop page URL from the button's data attribute
// 			const shopPageURL = filtersButton.getAttribute('data-shop-url');
// 			if (!shopPageURL) {
// 				console.error('Shop URL is missing in the data-shop-url attribute');
// 				return;
// 			}

// 			const filters = [];

// 			// Find all select elements within .filtersHome
// 			document.querySelectorAll('.filtersHome select').forEach(select => {
// 				const slug = select.getAttribute('name');
// 				const value = select.value;

// 				// Only add filters with selected values
// 				if (value) {
// 					filters.push(`${slug}[${value}]`);
// 				}
// 			});

// 			// Construct the final URL
// 			const queryString = filters.length > 0 ? `?filters=${filters.join('|')}` : '';
// 			const finalURL = `${shopPageURL}${queryString}`;

// 			// Redirect to the constructed URL
// 			window.location.href = finalURL;
// 		});
// 	}
// });


document.addEventListener("DOMContentLoaded", function () {
	const sortSelectors = document.querySelectorAll(".sort-bar__select");
	const clearButton = document.querySelector(".sort-bar__clear");

	if (sortSelectors && clearButton) {

		const urlParams = new URLSearchParams(window.location.search);
		let hasActiveFilters = false;

		sortSelectors.forEach((selector) => {
			const paramName = selector.name;
			const paramValue = urlParams.get(paramName);

			if (paramValue) {
				selector.value = paramValue;
				hasActiveFilters = true;
			} else {
				selector.value = "";
			}

			selector.addEventListener("change", function () {
				const newUrl = new URL(window.location.href);
				const newValue = this.value;

				if (newValue) {
					newUrl.searchParams.set(paramName, newValue);
				} else {
					newUrl.searchParams.delete(paramName);
				}

				window.location.href = newUrl.toString();
			});
		});

		if (hasActiveFilters) {
			clearButton.classList.remove("hidden");
		}

		clearButton.addEventListener("click", function () {
			const newUrl = new URL(window.location.href);

			sortSelectors.forEach((selector) => {
				const paramName = selector.name;
				newUrl.searchParams.delete(paramName);
			});

			window.location.href = newUrl.toString();
		});
	}
});

